import Switch, { SWITCH_TYPES } from './Switch';

export { SWITCH_TYPES };
export default Switch;
